var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');
var RolesCollection = require('../../collections/roles-collection');
var RoleModel = require('../../models/role-model');
var RoleFormView = require('./role-form');

var RolesRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/roles/roles-row.html'),

    ui: {
        hiddenableEdit: '.hiddenable',
        hiddenableComplimentEdit: '.hiddenable-compliment'
    },

    events: {
        'click .role-delete': 'removeRoles',
        'click input[type=checkbox]': 'onChecked',
        'keyup .role-name': 'onRoleNameChanged',
        'change .role-type': 'onRoleTypeChanged',
        'click .role-update': 'updateModel',
        'click .cancel': 'cancel'
    },

    templateContext: function () {
        var that = this;
        return {}
    },

    initialize: function (options) {
        _.bindAll(this, 'removeRoles', 'onChecked', 'onRoleNameChanged', 'onRoleTypeChanged', 'updateModel',
            'onModelChanged', 'cancel');
    },

    onRender: function () {
        this.ui.hiddenableEdit.hide();
        this.ui.hiddenableComplimentEdit.show();
        this.modelCopy = new RoleModel(_.clone(this.model.toJSON()));
    },

    removeRoles: function (event) {
        this.triggerMethod('delete:model', this.model);
    },

    onChecked: function (event) {
        this.model.set(event.target.value, event.target.checked);
        this.onModelChanged();
    },

    onRoleNameChanged: function (event) {
        if (this.model.get('templateName') != event.target.value) {
            this.model.set('templateName', event.target.value);
            this.onModelChanged();
        }
    },

    onRoleTypeChanged: function (event) {
        if (this.model.get('templateType') != event.target.value) {
            this.model.set('templateType', event.target.value);
            this.onModelChanged();
        }
    },

    onModelChanged: function () {
        this.ui.hiddenableEdit.show();
        this.ui.hiddenableComplimentEdit.hide();
        this.ui.hiddenableEdit.parent().css("background-color", "red");
    },

    updateModel: function () {
        this.triggerMethod('update:model', this.model);
    },

    cancel: function () {
        this.ui.hiddenableEdit.parent().css("background-color", "white");
        var modelOriginalCid = this.model.cid;
        this.model = new RoleModel(_.clone(this.modelCopy.toJSON()));
        this.model.cid = modelOriginalCid;
        this.triggerMethod('render:model', this.model);
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(13), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var RolesTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: RolesRowView,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'update:model': 'updateModel',
        'delete:model': 'deleteModel',
        'render:model': 'reRenderModel'
    },

    initialize: function (options) {
        _.bindAll(this, 'showLoading', 'hideLoading', 'logError', 'updateModel', 'deleteModel', 'reRenderModel');
        this.collection = options.collection;
    },

    childViewOptions: function () {
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    updateModel: function (model) {
        var that = this;
        var callback = function () {
            var cloned = model.clone();
            cloned.save();
            that.render();
        };
        this.triggerMethod('on:action', {callback: callback, mode: 'update'});
    },

    deleteModel: function (model) {
        var that = this;
        var responseHandler = function (model, xhr, options) {
            if (xhr.status == 200) {
                that.collection.remove(model);
                that.render();
            }
            else
                window.console.log('Error:' + ' ' + xhr.status);
        };
        var callback = function () {
            model.destroy({
                wait: true,
                success: responseHandler,
                error: responseHandler
            });
        }
        this.triggerMethod('on:action', {callback: callback, mode: 'delete'});
    },

    reRenderModel: function(model) {
        var childView = this.children.findByModelCid(model.cid);
        childView.render();
    }
});

var RolesView = Marionette.View.extend({
    tagName: 'div',
    className: 'roles-table',
    template: require('../../templates/roles/roles.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        updateConfirmationModal: '#yes-no-confirmation-modal-for-update',
        deleteConfirmationModal: '#yes-no-confirmation-modal-for-delete',
        rolesForm: '#roles-form'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed',
        'on:action': 'onAction',
        'role:saved': 'onRoleSaved'
    },

    callback: undefined,

    templateContext: function () {
        return {}
    },

    onRender: function () {
        window.document.title = "Roles";
        this.showChildView('body', new RolesTableBody({
            collection: this.collection
        }));

        this.showChildView('rolesForm', new RoleFormView());


        this.updateConfirmationModal = new YesNoConfirmationModal({
            title: 'Update confirmation',
            message: 'You are going to update role. Are you sure?'
        });
        this.showChildView('updateConfirmationModal', this.updateConfirmationModal);

        this.deleteConfirmationModal = new YesNoConfirmationModal({
            title: 'Remove confirmation',
            message: 'You are going to remove role. Are you sure?'
        });
        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
    },

    initialize: function (options) {
        var that = this;
        _.bindAll(that, 'saveConfirmed', 'onAction', 'onRoleSaved');
        that.collection = new RolesCollection();
        that.collection.fetch({
            success: function () {
                that.render;
            }
        });
    },

    onAction: function (data) {
        this.callback = data.callback;
        if (typeof this.callback !== "function")
            return;
        if (data.mode == 'update') {
            this.updateConfirmationModal.show();
        } else if (data.mode == 'delete') {
            this.deleteConfirmationModal.show();
        }
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.updateConfirmationModal.hide();
            this.deleteConfirmationModal.hide();
        }
    },

    onRoleSaved: function (model) {
        this.collection.add(model);
    }
});

module.exports = RolesView;


//////////////////
// WEBPACK FOOTER
// ./app/views/roles/roles-view.js
// module id = 446
// module chunks = 0